import * as THREE from "three";
/**
 * Sizes
 */
export const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

export const PLANE_HEIGHT_SEGMENTS = 100;
export const PLANE_WIDTH_SEGMENTS = 100;

export const DEFAULT_AOP_MAP_INTENSITY = 1;
export const DEFAULT_NORMAL_SCALE = 1;
export const DEFAULT_DISPLACEMENT_SCALE = 0.05;
export const DEFAULT_FACE = THREE.DoubleSide;
